import React, { useState, useEffect } from 'react';
import { Plus, History, Search, Loader2, FileSpreadsheet } from 'lucide-react';
import { PageTitle } from '../../../../_metronic/layout/core';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { ConsultantTable } from './ConsultantTable';
import { ConsultantModal } from './ConsultantModal';
import { ConfirmDeleteModal } from './ConfirmDeleteModal';
import { HistoryModal } from './HistoryModal';
import { StatsCard } from './StatsCard';
import { SearchInput } from './SearchInput';
import * as API from '../../../api';

export const UnbilledOrders = () => {
  const [consultants, setConsultants] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedConsultant, setSelectedConsultant] = useState<any>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [distributors, setDistributors] = useState<any[]>([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const response:any = await API.getConsultants();
      console.log(response.data);
      setConsultants(response.data);
    } catch (error) {
      console.error('Error loading consultants:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (consultant: any) => {
    setSelectedConsultant(consultant);
    setShowAddModal(true);
  };

  const handleDelete = (consultant: any) => {
    setSelectedConsultant(consultant);
    setShowDeleteModal(true);
  };

  const handleSave = async (consultantData: any) => {
    try {
      if (selectedConsultant) {
        await API.updateConsultant(selectedConsultant.guid, consultantData);
      } else {
        await API.createConsultant(consultantData);
      }
      loadData();
      setShowAddModal(false);
      setSelectedConsultant(null);
    } catch (error) {
      console.error('Error saving consultant:', error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await API.deleteConsultant(selectedConsultant.guid);
      loadData();
      setShowDeleteModal(false);
      setSelectedConsultant(null);
    } catch (error) {
      console.error('Error deleting consultant:', error);
    }
  };

  const filteredConsultants = consultants.filter(consultant => 
    consultant.consultant.toLowerCase().includes(searchTerm.toLowerCase()) ||
    consultant.consultant_mail.toLowerCase().includes(searchTerm.toLowerCase()) ||
    consultant.coordinator.toLowerCase().includes(searchTerm.toLowerCase()) ||
    consultant.coordinator_mail.toLowerCase().includes(searchTerm.toLowerCase()) ||
    consultant.manager.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <PageTitle>Pedidos Não Faturado</PageTitle>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setShowHistoryModal(true)}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors inline-flex items-center gap-2"
              >
                <History className="w-5 h-5" />
                Histórico
              </button>
              <button
                onClick={() => setShowAddModal(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center gap-2"
              >
                <Plus className="w-5 h-5" />
                Novo Consultor
              </button>
            </div>
          </div>

          <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            <StatsCard
              title="Total de Consultores"
              value={consultants.length}
              description="Consultores cadastrados"
              icon={<FileSpreadsheet className="w-6 h-6" />}
            />
            {searchTerm && (
              <StatsCard
                title="Resultados da Busca"
                value={filteredConsultants.length}
                description="Consultores encontrados"
                icon={<Search className="w-6 h-6" />}
              />
            )}
          </div>
        </div>

        {/* Search */}
        <div className="mb-6">
          <SearchInput
            value={searchTerm}
            onChange={setSearchTerm}
            placeholder="Buscar por nome, email, coordenador ou gerente..."
          />
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12">
              <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
              <p className="mt-4 text-gray-500">Carregando dados...</p>
            </div>
          ) : !consultants.length ? (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="bg-gray-100 rounded-full p-3">
                <FileSpreadsheet className="w-8 h-8 text-gray-400" />
              </div>
              <p className="mt-4 text-gray-500">Nenhum consultor encontrado</p>
            </div>
          ) : (
            <ConsultantTable
              consultants={filteredConsultants}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </div>
      </div>

      {/* Modals */}
      <ConsultantModal
        isOpen={showAddModal}
        consultant={selectedConsultant}
        distributors={distributors}
        onClose={() => {
          setShowAddModal(false);
          setSelectedConsultant(null);
        }}
        onSave={handleSave}
      />

      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        consultant={selectedConsultant}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedConsultant(null);
        }}
        onConfirm={handleConfirmDelete}
      />

      <HistoryModal
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
      />
    </div>
  );
};

export default UnbilledOrders;